/**
 * 実行
 */

import { listen, prefetch } from "quicklink";
import 'intersection-observer';
import isn from './intersection.js';
import fun from './functions.js';
import smoothscroll from "smoothscroll-polyfill";

(function () {
  "use strict";

  document.body.classList.add("js-validity");

  isn.DataElementHide("[data-element_hide]");
  isn.DataScroll("[data-scroll]");
  isn.DataSrc("[data-src]");
  isn.DataHref("[data-href]");
  isn.DataBack("[data-back]");
  smoothscroll.polyfill();
  fun.SmoothLink();

  const data_click = document.querySelectorAll("[data-click]");
  for (let i = 0, len = data_click.length; i < len; ++i) {
    data_click[i].addEventListener("click", e => {
      const click = data_click[i].dataset.click;
      switch (click) {
        case "menu":
          if (data_click[i].getAttribute("aria-expanded") == "false") {
            fun.MenuOpen(data_click[i]);
          } else {
            fun.MenuClose(data_click[i]);
          }
          break;
        case "toggle":
          fun.ClickToggle(data_click[i]);
          break;
        case "go_top":
          fun.ClickGoTop(data_click[i]);
          break;
        case "modal_open":
          fun.ClickModalOpen(data_click[i]);
          break;
        case "modal_close":
          fun.ClickModalClose(data_click[i]);
          break;
      }
    });
  }

  const data_tab = document.querySelectorAll("[data-tab] > li");
  for (let i = 0, len = data_tab.length; i < len; ++i) {
    data_tab[i].addEventListener("click", e => {
      fun.ClickTab(data_tab[i]);
    });
  }

  const data_tab2 = document.querySelectorAll('[data-tab="2"]');
  const tab_contents = document.querySelectorAll('[data-tab_contents="1"] > div');
  for (let i = 0, len = data_tab2.length; i < len; ++i) {
    data_tab2[i].addEventListener("click", e => {
        for (let i = 0, len = tab_contents.length; i < len; ++i) {
        tab_contents[i].classList.remove("js-open");
      }
    });
  }

  const data_tab3 = document.querySelectorAll('[data-tab="1"]');
  const tab_contents1 = document.querySelectorAll('[data-tab_contents="2"] > div');
  for (let i = 0, len = data_tab3.length; i < len; ++i) {
    data_tab3[i].addEventListener("click", e => {
        for (let i = 0, len = tab_contents1.length; i < len; ++i) {
          tab_contents1[i].classList.remove("js-open");
      }
    });
  }

  const targetblank_flag_val = document.body.dataset.targetblank_flag;
  if (targetblank_flag_val == true) {
    fun.TargetBlank();
  }

  const links = document.querySelectorAll('a[href*="#"]');
  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener("click", e => {
      const hash = links[i].hash;
      const href = links[i].href;
      const hrefPageUrl = href.split("#")[0];
      const location_href = location.href;
      const currentUrl = location_href.split("#")[0];
      if (hrefPageUrl == currentUrl) {
        e.preventDefault();
        if (links[i].classList.contains("js-not-smooth-scroll")) return;
        fun.SmoothLinkSame(hash);
        fun.MenuClose(document.getElementById("menu_button"));
      }
    });
  }

  window.addEventListener('load', () => {
    const quicklink_flag_val = document.body.dataset.quicklink_flag;
    if (quicklink_flag_val == true) {
      const quicklink_exclude_val = document.body.dataset.quicklink_exclude;
      const exclude_data = quicklink_exclude_val.split(',');

      let exclude = [];
      for( let i=0; i < exclude_data.length; i++) {
        exclude[i] = new RegExp(exclude_data[i].trim());
      }

      listen({
        ignores: [
          /\/wp-admin\/?/,
          /\/wp-login\/?/,
          exclude,
          uri => uri.includes("#"),
          (uri, elem) => elem.hasAttribute("noprefetch")
          // or RegExp: /#(.+)/
          // or element matching: (uri, elem) => !!elem.hash
        ]
      });
    }
  });

  // slide

  if (window.matchMedia('(max-width: 767px)').matches) {

    jQuery(function($) {
    
        $('.slider').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            speed:1000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
        });

    });

 } else if (window.matchMedia('(max-width: 1263px)').matches) {
    jQuery(function($) {
    
        $('.slider').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            speed:1000,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
    
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
        });

    });
 }
 
})();
